import React, { useEffect, useState } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { Checkbox, Row, Select, Card, Form, Input, Modal, Spin, Col, Button, Space, Typography } from 'antd'
import InputMask from 'react-input-mask'
import { EmptyHeaderHero } from './components'
import { checkGWAccount, getSecurityQuestions, getWebsiteMaintenanceStatus, registerAccount, verifyLogin } from '../services'
import { getDomain, getHostName } from '../utils'
import Router from 'next/router'
import { checkSelfService } from '../services/Api'

import RegisterStyle from '../../styles/Register.module.css'

const { Option } = Select
const { Text } = Typography

const antIcon = <LoadingOutlined spin style={{ fontSize: 24 }} />

const securityQuestions = [
  {
    Code: 'MAIDEN',
    Text: "What is your mother's maiden name?"
  },
  {
    Code: 'SINGERBAND',
    Text: 'Who is your favorite singer or band?'
  },
  {
    Code: 'MOVIE',
    Text: 'What is your favorite movie?'
  },
  {
    Code: 'FIRSTCARCOLOR',
    Text: 'What was the color of your first car?'
  },
  {
    Code: 'STREETNAME',
    Text: 'What is the name of the street you grew up on?'
  }
]

const getEnvSite = () => {
  if (typeof window !== 'undefined') {
    switch (window.location.hostname) {
      case 'localhost':
        return 'https://getquotestg.cure.com/ServiceInterruption.aspx'
      case 'staging.cure.com':
        return 'https://getquotestg.cure.com/ServiceInterruption.aspx'
      case 'prepublish.cure.com':
        return 'https://getquoteprep.cure.com/ServiceInterruption.aspx'
      default:
        return 'https://getquote.cure.com/ServiceInterruption.aspx'
    }
  }
}

const Register = () => {
  const [filteredQuestions, setFilteredQuestions] = useState([])
  const [questionVals, setQuestionVals] = useState([null, null, null])
  const [visible, setVisible] = useState(false)
  const [message, setMessage] = useState(null)
  const [user, setUser] = useState({
    PolicyNumber: '',
    Zip: '',
    EmailAddress: '',
    FirstName: '',
    LastName: '',
    DOB: '',
    Password: '',
    RetypePassword: '',
    SecurityQuestion1: '',
    SecurityQuestion2: '',
    SecurityQuestion3: '',
    SecurityAnswer1: '',
    SecurityAnswer2: '',
    SecurityAnswer3: '',
    Env: getHostName()
  })
  const [isAgreed, setIsAgreed] = useState(false)
  const [showAgreement, setShowAgreement] = useState(false)
  const [selectedState, setSelectedState] = useState(null)
  const [showSpinner, setShowSpinner] = useState(false)
  const [passwordValidationError, setPasswordValidationError] = useState(false)
  const [passwordMatchValidationError, setPasswordMatchValidationError] = useState(false)
  const [showMIWarningModal, setshowMIWarningModal] = useState(false)

  useEffect(() => {
    if (!showMIWarningModal) {

    }
  }, [showMIWarningModal])

  useEffect(() => {
    const search = window.location.search
    const params = new URLSearchParams(search)
    setSelectedState(params.get('state'))
  }, [])
  useEffect(() => {
    async function fetchWebsiteMaintainence() {
      const websiteStatusResponse = await getWebsiteMaintenanceStatus()
      if (websiteStatusResponse && websiteStatusResponse.data) {
        const status = websiteStatusResponse.data
        if (
          status.Result == "Active" && status?.Pages.includes("MyAccountLogin")
          && !status.AllowAccessPages.includes("MyAccountLogin")
        ) {
          window.location.href = getEnvSite()
        }
      }
    }
    fetchWebsiteMaintainence()

    async function fetchSecurityQuestions() {
      const response = await getSecurityQuestions()
      const data = response.data.filter(obj => obj.Code !== '')
      setFilteredQuestions(data)
    }
    if (filteredQuestions && filteredQuestions.length === 0) {
      fetchSecurityQuestions()
    }
  }, [filteredQuestions])

  const handleQuestionValChange = (option, index) => {
    const newQuestionVals = [...questionVals]
    newQuestionVals[index] = option
    setQuestionVals(newQuestionVals)
  }

  const getAvailableOptions = () => {
    const availableOptionsLeft = [...filteredQuestions]
    return availableOptionsLeft.filter(questionOption => {
      return questionVals.indexOf(questionOption.Code) === -1
    })
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  const handleSubmit = async () => {
    updatePendo(user)
    setMessage(null)
    setShowAgreement(false)
    setShowSpinner(true)
    const updatedUser = { ...user }
    delete updatedUser.RetypePassword
    let checkgwaccount_resp = await checkGWAccount({ FirstName: user.FirstName, LastName: user.LastName, DOB: user.DOB, EmailAddress: user.EmailAddress, PolicyNumber: user.PolicyNumber })
    if (checkgwaccount_resp && checkgwaccount_resp.data) {
      if (checkgwaccount_resp.data.Result !== 'Success') {
        //proceed as usual
        const response = await registerAccount(user)
        setShowSpinner(false)
        if (response && response.data && response.data.Result === 'Account Created') {

          // Check self service table if policy is blocked from logging in
          var env = (user?.FirstName?.includes("_uat")) ? "uat" : "prod";
          const selfServiceResponse = await checkSelfService(user.PolicyNumber, env)
          if (selfServiceResponse?.data?.Result != null) {
            setMessage(selfServiceResponse?.data?.Result)
            setShowSpinner(false)
          }
          else {
            setShowAgreement(true)
            scrollToTop()
          }
        }
        else if (response && response.data && (response.data.Result === "Account Already Migrated" || response.data.Result === "Policy Number Already Registered."))
          setMessage("Policy number already registered. Forgot Username/Email Address?")
        else if (response.data.Result === "Email Address Already Registered.") {
          setMessage("Email address already registered with another account.")
        } else if (response && response.data && response.data.Result) {
          setMessage(response.data.Result)
        } else {
          setMessage("An error has occured.")
        }
      }
      else if (checkgwaccount_resp.data.Result === 'Success' && checkgwaccount_resp.data?.Account?.Converted == 'no') {
        setShowSpinner(false)
        localStorage.setItem("gwAccountUser", JSON.stringify(user))
        Router.push({ pathname: `/my-account/update`, query: { verifiedUser: user.EmailAddress } });
      }
      else if (checkgwaccount_resp.data.Result === 'Success') {
        setShowSpinner(false)
        setMessage("Policy number already registered. Forgot Username/Email Address?")
      }
    }
    setMessage(response.data.Result)
    if (response && response.data && response.data.Result === 'MI Policy') {
      setshowMIWarningModal(true)
    }
    setShowSpinner(false)
  }

  const navigateToSite = async () => {
    setShowSpinner(true)
    const clonedUser = { ...user }
    const response = await verifyLogin(clonedUser.EmailAddress, clonedUser.Password, 'login')
    if (response && response.data) {
      const { Result, Tkn } = response.data
      if (Result === 'Success') {
        const url = `https://${getDomain('account')}/home?tkn=${Tkn}`
        window.location = url
      } else {
        setShowSpinner(false)
      }
    } else {
      setShowSpinner(false)
    }
  }

  const updateTextFields = (text, field, isDate) => {
    const clonedUser = { ...user }
    if (isDate && text) {
      clonedUser[field] = text
    } else {
      clonedUser[field] = text
    }
    setUser(clonedUser)
  }

  const updatePendo = (user) => {
    window.pendo.identify({
      visitor: {
        id: user?.EmailAddress,
        change_type: "Account Registration",
        email: user?.EmailAddress,
        full_name: user?.FirstName + " " + user?.LastName
      },
      account: {
        id: user?.PolicyNumber,
        change_type: "Account Registration",
        policyNumber: user?.PolicyNumber,
        email: user?.EmailAddress,
        full_name: user?.FirstName + " " + user?.LastName
      }
    });

    // Log pendo to the console
    console.log(window?.pendo?.validateInstall())
  }

  const isFormValid = () => {
    let response = false
    if (
      user.FirstName.length === 0 ||
      user.LastName.length === 0 ||
      user.PolicyNumber.length === 0 ||
      user.EmailAddress.length === 0 ||
      user.Password.length === 0 ||
      user.DOB.length === 0 ||
      user.RetypePassword.length === 0 ||
      user.SecurityQuestion1.length === 0 ||
      user.SecurityQuestion2.length === 0 ||
      user.SecurityQuestion3.length === 0 ||
      user.SecurityAnswer1.length === 0 ||
      user.SecurityAnswer2.length === 0 ||
      user.SecurityAnswer3.length === 0
    ) {
      response = true
    }
    if (!response) {
      if (new Date(user.DOB).toString() === 'Invalid Date') {
        response = true
      }
    }
    if (!response) {
      const regEx = /\S+@\S+\.\S+/
      if (user.EmailAddress.length > 0 && !regEx.test(user.EmailAddress)) {
        response = true
      }
    }
    if (!response) {
      if (user.Password.length > 0 && user.RetypePassword.length > 0) {
        if (user.Password === user.RetypePassword) {
          const isValidLength = /^(?=.*[0-9])(?=.*[A-Z]).{5,}$/
          if (!isValidLength.test(user.Password)) {
            response = true
          } else {
            response = false
          }
        } else {
          response = true
        }
      }
    }
    return response
  }

  const validatePassword = (password, retypePassword) => {
    setPasswordValidationError(false)
    setPasswordMatchValidationError(false)
    if (password.length > 0) {
      const isValidLength = /^(?=.*[0-9])(?=.*[A-Z]).{5,}$/
      if (!isValidLength.test(password)) {
        setPasswordValidationError(true)
      } else {
        setPasswordValidationError(false)
      }
    }
    if (retypePassword.length > 0) {
      const isValidLength = /^(?=.*[0-9])(?=.*[A-Z]).{5,}$/
      if (!isValidLength.test(retypePassword)) {
        setPasswordValidationError(true)
      } else {
        setPasswordValidationError(false)
      }
    }
    if (password.length > 0 && retypePassword.length > 0) {
      if (password !== retypePassword) {
        setPasswordMatchValidationError(true)
      } else {
        setPasswordMatchValidationError(false)
      }
    }
  }

  const handleKeyDown = event => {
    if (event.key === 'Enter' && !isFormValid()) {
      handleSubmit()
    }
  }


  const handleOkBtnClick = () => {
    setVisible(false)
  }

  const securityQuestion1 = securityQuestions.filter(question => question.Code === user.SecurityQuestion1)[0]
  const securityQuestion2 = securityQuestions.filter(question => question.Code === user.SecurityQuestion2)[0]
  const securityQuestion3 = securityQuestions.filter(question => question.Code === user.SecurityQuestion3)[0]

  return (
    <>
      {!showAgreement && (
        <>
          <EmptyHeaderHero title="Account Registration" />
          <div className={`${RegisterStyle["register-screen"]}`}>
            <Row>
              <Card className={`${RegisterStyle["register-card"]}`}>
                <h5 className={`${RegisterStyle["sub-label"]}`}>Policy Information</h5>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${RegisterStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${RegisterStyle["input-text"]}`}
                        onChange={event => updateTextFields(event.target.value, 'FirstName')}
                        onKeyDown={handleKeyDown}
                        placeholder="First Name*"
                        value={user.FirstName}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${RegisterStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${RegisterStyle["input-text"]}`}
                        onChange={event => updateTextFields(event.target.value, 'LastName')}
                        onKeyDown={handleKeyDown}
                        placeholder="Last Name*"
                        value={user.LastName}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${RegisterStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${RegisterStyle["input-text"]}`}
                        onChange={event => updateTextFields(event.target.value, 'PolicyNumber')}
                        onKeyDown={handleKeyDown}
                        placeholder="Policy Number*"
                        value={user.PolicyNumber}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${RegisterStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${RegisterStyle["input-text"]}`}
                        maxLength={5}
                        onChange={event => {
                          const value = event.target.value.replace(/\D/g, '')
                          updateTextFields(value, 'Zip')
                        }}
                        onKeyDown={handleKeyDown}
                        placeholder="Zip Code*"
                        value={user.Zip}
                        type='tel'
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${RegisterStyle["margin-bottom-12"]}`}>
                      <InputMask
                        className={`${RegisterStyle["dob"]}`}
                        mask="99/99/9999"
                        onChange={event => updateTextFields(event.target.value, 'DOB', true)}
                        placeholder="DOB (mm/dd/yyyy)*"
                        value={user.DOB}
                        type='tel'
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${RegisterStyle["margin-bottom-12"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${RegisterStyle["input-text"]}`}
                        onChange={event => updateTextFields(event.target.value, 'EmailAddress')}
                        onKeyDown={handleKeyDown}
                        placeholder="Email Address*"
                        value={user.EmailAddress}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className={`${RegisterStyle["margin-bottom-12"]}`}>
                  <Col className={`${RegisterStyle["text-wrapper"]}`} span={24}>
                    <Text>Passwords must have at least 5 characters with 1 number and 1 capital letter.</Text>
                  </Col>
                </Row>
                <Row>
                  <Col className={`${RegisterStyle["account-margin"]}`} xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${RegisterStyle["margin-bottom-4"]}`}>
                      <Input.Password
                        autoComplete="off"
                        className={`${RegisterStyle["input-text"]}`}
                        iconRender={visible => (visible ? 'Hide' : 'Show')}
                        onBlur={event => validatePassword(event.target.value, user.RetypePassword)}
                        onChange={event => updateTextFields(event.target.value, 'Password')}
                        onKeyDown={handleKeyDown}
                        placeholder="Password*"
                        type="password"
                        value={user.Password}
                      />
                    </Form.Item>
                  </Col>
                  <Col className={`${RegisterStyle["account-margin"]}`} xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${RegisterStyle["margin-bottom-4"]}`}>
                      <Input.Password
                        autoComplete="off"
                        className={`${RegisterStyle["input-text"]}`}
                        iconRender={visible => (visible ? 'Hide' : 'Show')}
                        onBlur={event => validatePassword(user.Password, event.target.value)}
                        onChange={event => updateTextFields(event.target.value, 'RetypePassword')}
                        onKeyDown={handleKeyDown}
                        placeholder="Confirm Password*"
                        type="password"
                        value={user.RetypePassword}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                {passwordValidationError && (
                  <Row className={`${RegisterStyle["margin-top-12"]}`}>
                    <Col className={`${RegisterStyle["text-wrapper"]}`} span={24}>
                      <Text className={`${RegisterStyle["error-msg"]}`}>
                        Passwords must have at least 5 characters with 1 number and 1 capital letter.
                      </Text>
                    </Col>
                  </Row>
                )}
                {!passwordValidationError && passwordMatchValidationError && (
                  <Row className={`${RegisterStyle["margin-top-12"]}`}>
                    <Col className={`${RegisterStyle["text-wrapper"]}`} span={24}>
                      <Text className={`${RegisterStyle["error-msg"]}`}>Password and Confirm Password do not match.</Text>
                    </Col>
                  </Row>
                )}
                <h5 className={`${RegisterStyle["sub-label"]} ${RegisterStyle["account-margin"]} ${RegisterStyle["security"]} ${RegisterStyle["margin-bottom-0"]}`}>Security Questions</h5>
                <Text className={`${RegisterStyle["security-disclaimer"]}`}>
                  Please note: In the future, security answers need to be entered exactly as they are here.
                </Text>
                <Row className={`${RegisterStyle["margin-bottom-14"]}`}>
                  <Col className={`${RegisterStyle["account-margin-select"]}`} xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Select
                      dropdownClassName={`${RegisterStyle["security-questions"]}`}
                      onChange={e => {
                        handleQuestionValChange(e, 0)
                        updateTextFields(e, 'SecurityQuestion1')
                      }}
                      placeholder="Select a security question*"
                      value={securityQuestion1?.Text}
                    >
                      {getAvailableOptions().map((question, index) => (
                        <Option key={index} value={question.Code}>
                          {question.Text}
                        </Option>
                      ))}
                    </Select>
                  </Col>
                  <Col className={`${RegisterStyle["account-margin"]}`} xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${RegisterStyle["input-text"]}`}
                      onChange={event => updateTextFields(event.target.value, 'SecurityAnswer1')}
                      onKeyDown={handleKeyDown}
                      placeholder="Security Answer 1*"
                      value={user.SecurityAnswer1}
                    />
                  </Col>
                </Row>
                <Row className={`${RegisterStyle["margin-bottom-14"]}`}>
                  <Col className={`${RegisterStyle["account-margin-select"]}`} xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Select
                      dropdownClassName={`${RegisterStyle["security-questions"]}`}
                      onChange={e => {
                        handleQuestionValChange(e, 1)
                        updateTextFields(e, 'SecurityQuestion2')
                      }}
                      placeholder="Select a security question*"
                      value={securityQuestion2?.Text}
                    >
                      {getAvailableOptions().map((question, index) => (
                        <Option key={index} value={question.Code}>
                          {question.Text}
                        </Option>
                      ))}
                    </Select>
                  </Col>
                  <Col className={`${RegisterStyle["account-margin"]}`} xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${RegisterStyle["input-text"]}`}
                      onChange={event => updateTextFields(event.target.value, 'SecurityAnswer2')}
                      onKeyDown={handleKeyDown}
                      placeholder="Security Answer 2*"
                      value={user.SecurityAnswer2}
                    />
                  </Col>
                </Row>
                <Row className={`${RegisterStyle["margin-bottom-14"]}`}>
                  <Col className={`${RegisterStyle["account-margin-select"]}`} xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Select
                      dropdownClassName={`${RegisterStyle["security-questions"]}`}
                      onChange={e => {
                        handleQuestionValChange(e, 2)
                        updateTextFields(e, 'SecurityQuestion3')
                      }}
                      placeholder="Select a security question*"
                      value={securityQuestion3?.Text}
                    >
                      {getAvailableOptions().map((question, index) => (
                        <Option key={index} value={question.Code}>
                          {question.Text}
                        </Option>
                      ))}
                    </Select>
                  </Col>
                  <Col className={`${RegisterStyle["account-margin"]}`} xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Input
                      autoComplete="off"
                      className={`${RegisterStyle["input-text"]}`}
                      onChange={event => updateTextFields(event.target.value, 'SecurityAnswer3')}
                      onKeyDown={handleKeyDown}
                      placeholder="Security Answer 3*"
                      value={user.SecurityAnswer3}
                    />
                  </Col>
                </Row>
                {/* <h5 className={`${RegisterStyle["sub-label"]} ${RegisterStyle["account-margin"]} ${RegisterStyle["security"]} ${RegisterStyle["margin-bottom-0"]}`}>Want to stay in the loop?</h5>
                <Text className={`${RegisterStyle["security-disclaimer"]}`}>
                  Please make the following selection to choose to opt-in or out for text updates with important information about your policy.
                </Text>
                <Row className="">
                  <Col className={`${RegisterStyle["account-margin-select"]}`} xl={{ span: 10 }} xs={{ span: 24 }}>
                    <Radio.Group>
                      <Radio value={1}>I opt-in to receiving text updates about my policy.</Radio>
                      <Radio value={2}>I opt-out to receiving text updates about my policy.</Radio>
                    </Radio.Group>
                  </Col>
                </Row>
                <Row className="">
                  <Col className="" xl={{ span: 12 }} xs={{ span: 24 }}>
                    <Text className="options-disclaimer">
                      Message and data rates may apply. Reply STOP to opt-out at any time.
                    </Text>
                  </Col>
                  <Col className={`${RegisterStyle["account-margin-select"]}`} xl={{ span: 18 }} xs={{ span: 24 }}>
                    <a className='terms-condition-link' onClick={() => setVisible(true)}>
                      <Text className="">
                        Terms and Conditions
                      </Text>
                    </a> 
                  </Col>
                </Row> */}
                {message && (
                  <Row className={`${RegisterStyle["margin-bottom-14"]}`}>
                    {/* <Col className={`${RegisterStyle["account-margin-select"]}`} xl={{ span: 8 }} xs={{ span: 24 }}> */}
                    {message !== 'Account Created' && message !== "Policy number already registered. Forgot Username/Email Address?" && <Text className={`${RegisterStyle["error-msg"]}`}>{message}</Text>}
                    {message === "Policy number already registered. Forgot Username/Email Address?" && <Text className={`${RegisterStyle["error-msg"]}`}>Policy number already registered. <span style={{ textDecoration: "underline", cursor: "pointer", fontWeight: "bold" }} onClick={() => Router.push("/my-account/forgot-email/")}>Forgot Username/Email Address?</span></Text>}
                    {message === 'Account Created' && (
                      <>
                        <Text className={`${RegisterStyle["success-msg"]}`}>Thank you. Your account has been created.</Text>{' '}
                        <a className={`${RegisterStyle["success-msg"]}`} href="/my-account" target="_blank">
                          Log in now.
                        </a>
                      </>
                    )}
                    {/* </Col> */}
                  </Row>
                )}
                <Row className={`${RegisterStyle["submit-container"]}`}>
                  <Form.Item className={`${RegisterStyle["btn-control"]} ${RegisterStyle["button-submit-form"]}`}>
                    <Space>
                      <Button
                        className={`${RegisterStyle["register"]} ${RegisterStyle["register-form-button"]}`}
                        disabled={isFormValid()}
                        onClick={() => handleSubmit()}
                      >
                        Register
                      </Button>
                      {showSpinner && <Spin indicator={antIcon} style={{ marginLeft: 24 }} />}
                    </Space>
                  </Form.Item>
                </Row>
              </Card>
            </Row>
          </div>
        </>
      )}
      {showAgreement && (
        <div className={`${RegisterStyle["register-screen"]}`}>
          <EmptyHeaderHero minHeight={true} title="Agreement To Conduct Business Electronically" />
          <div className={`${RegisterStyle["electronics-terms-and-condition-screen"]}`}>
            <Row justify="center">
              <Card className={`${RegisterStyle["electronics-terms-and-condition-card"]}`}>
                <p className={`${RegisterStyle["sub-text"]} ${RegisterStyle["margin-bottom-12"]}`}>
                  You <span className={`${RegisterStyle["bold"]}`}>MUST</span> read through and scroll to the bottom.
                </p>
                <p className={`${RegisterStyle["sub-text"]}`}>
                  State law permits parties which have agreed to conduct transactions by electronic means to enter into
                  an agreement online provided the requirements of the applicable laws are met. State law requires CURE
                  to obtain your consent to electronically sign insurance application documents and to provide you with
                  an electronic copy of your documents.
                </p>

                <h5 className={`${RegisterStyle["small"]}`}>An Electronic Signature:</h5>
                <p className={`${RegisterStyle["sub-text"]}`}>
                  An electronic signature is an electronic sound, symbol, or process attached to or logically associated
                  with a record that is executed or adopted by a person to demonstrate their intent to sign the record.
                  When you decide to apply online for insurance coverage with CURE, you are required to electronically
                  sign the following documents: an Agreement to Conduct Business Electronically, an Application, and a
                  Power of Attorney.
                </p>
                <p className={`${RegisterStyle["sub-text"]}`}>
                  Once coverage is bound, CURE will send you a Coverage Selection Form showing your coverage selections
                  on which you may make any changes and/or corrections. A Buyer&apos;s Guide, the Insurance Scenarios,
                  and the Consumer Bill of Rights will also accompany the Coverage Selection Form.
                </p>
                <p className={`${RegisterStyle["sub-text"]}`}>
                  You also have the option to obtain a copy of your application documents in a non-electronic format if
                  you so choose. To receive paper copies of documents that are delivered electronically, or to withdraw
                  consent to receive such documents electronically, please follow the instructions set forth below in
                  the section titled &quot;WITHDRAWAL OF CONSENT & REQUEST FOR PAPER DOCUMENTS&quot;
                </p>

                <h5 className={`${RegisterStyle["small"]}`}>Withdrawal of Consent and Request for Paper Documents:</h5>
                <p className={`${RegisterStyle["sub-text"]}`}>
                  You may withdraw your consent to obtain your application documents electronically or request paper
                  copies of documents that are delivered electronically by sending a written request to CURE, Attention:
                  Underwriting Department, 214 Carnegie Center, Suite 301, Princeton, New Jersey 08540.
                </p>

                <h5 className={`${RegisterStyle["small"]}`}>Application to CURE by Telephone:</h5>
                <p className={`${RegisterStyle["sub-text"]}`}>
                  If you have obtained a quote with CURE but do not want to apply for a policy using the electronic
                  transaction option, please call us at 1-800-535-2873. Our representatives will be glad to assist you
                  with your automobile insurance needs.
                </p>

                <h5 className={`${RegisterStyle["small"]}`}>
                  Hardware and Software Requirements for Access to and Retention of Electronic Records:
                </h5>
                <p className={`${RegisterStyle["sub-text"]}`}>
                  To access CURE&apos;s website and obtain electronic application documents, you must have the ability
                  to access the Internet using a web browser such as Microsoft Internet Explorer, Google Chrome or
                  Firefox. A valid e-mail address, Adobe Acrobat Reader and a printer are also required in order to
                  receive, view, and print certain application documents. CURE uses modern encrypt protocols while
                  accessing sensitive information during online transactions.
                </p>
                <p className={`${RegisterStyle["sub-text"]}`}>
                  Should CURE change hardware and software requirements for access to and retention of electronic
                  records, such that the change creates a material risk that you will not be able to access or retain
                  your subsequent electronic records (the subject of your prior consent), CURE will provide you with a
                  statement of:
                </p>
                <p className={`${RegisterStyle["sub-text"]}`}>
                  <b>•</b> The revised hardware and software requirements for access to and retention of your electronic
                  records.
                </p>
                <p className={`${RegisterStyle["sub-text"]}`}>
                  <b>•</b> Your right to withdraw consent without imposition of a fee for such withdrawal and without
                  the imposition of any condition or consequence that was not disclosed above.
                </p>

                <h5 className={`${RegisterStyle["small"]}`}>Statement of Understanding:</h5>
                {selectedState === 'NJ' && (
                  <>
                    <p className={`${RegisterStyle["sub-text"]}`}>
                      I understand that my application documents will be sent to me electronically if I consent to
                      electronically sign my application. I also understand that I may make changes to my coverages
                      using the Coverage Selection Form that will be sent to me along with the Buyer&apos;s Guide, the
                      Insurance Scenarios, and the Consumer Bill of Rights.
                    </p>
                    <p className={`${RegisterStyle["sub-text"]}`}>
                      In addition, I agree to accept all other documents relating to my policy electronically provided
                      they are not required by law to be mailed, with the knowledge that I may withdraw consent to
                      receive those insurance documents electronically by following the instructions set forth above in
                      the section titled &quot;WITHDRAWAL OF CONSENT & REQUEST FOR PAPER DOCUMENTS.&quot;
                    </p>
                  </>
                )}
                {selectedState === 'PA' && (
                  <>
                    <p className={`${RegisterStyle["sub-text"]}`}>
                      I understand that my application documents will be sent to me electronically if I consent to
                      electronically sign my application. I agree to accept all other documents relating to my policy
                      electronically provided they are not required by law to be mailed, with the knowledge that I may
                      withdraw consent to receive those insurance documents electronically by following the instructions
                      set forth above in the section titled &quot;WITHDRAWAL OF CONSENT & REQUEST FOR PAPER
                      DOCUMENTS.&quot;
                    </p>
                    <p className={`${RegisterStyle["sub-text"]}`}>
                      In addition, I agree to accept all other documents relating to my policy electronically provided
                      they are not required by law to be mailed, with the knowledge that I may withdraw consent to
                      receive those insurance documents electronically by following the instructions set forth above in
                      the section titled &quot;WITHDRAWAL OF CONSENT & REQUEST FOR PAPER DOCUMENTS.&quot;
                    </p>
                  </>
                )}
                <p className={`${RegisterStyle["sub-text"]}`}>
                  I understand that I have the right to withdraw consent to receive my insurance application documents
                  electronically, without imposition of a fee for such withdrawal and without the imposition of any
                  condition or consequence that was not disclosed above, by following the instructions set forth above
                  in the section titled &quot;WITHDRAWAL OF CONSENT & REQUEST FOR PAPER DOCUMENTS.&quot;
                </p>
                <p className={`${RegisterStyle["sub-text"]}`}>
                  I understand that I have the option to obtain a copy of my application documents in a non-electronic
                  format by following the instructions set forth above in the section titled &quot;WITHDRAWAL OF CONSENT
                  & REQUEST FOR PAPER DOCUMENTS.&quot;
                </p>
                <p className={`${RegisterStyle["sub-text"]}`}>
                  I understand that withdrawal of consent will terminate the online transaction which I have begun.
                </p>
                <p />
                <Checkbox checked={isAgreed} onChange={event => setIsAgreed(event.target.checked)}>
                  I agree to the terms above.
                </Checkbox>
                <p />
                <p />
                <Row className={`${RegisterStyle["agreement-submit-container"]}`}>
                  <Form.Item className={`${RegisterStyle["btn-control"]} ${RegisterStyle["button-submit-form"]}`}>
                    <Button className={`${RegisterStyle["form-button"]}`} disabled={!isAgreed} onClick={navigateToSite}>
                      Agree
                    </Button>
                    {showSpinner && <Spin indicator={antIcon} style={{ marginLeft: 24 }} />}
                  </Form.Item>
                </Row>
              </Card>
            </Row>
          </div>
        </div>
      )}
      <Modal
        title="TERMS AND CONDITIONS"
        visible={visible}
        className={`${RegisterStyle["register-modal"]}`}
        onOk={handleOkBtnClick}
        okText="CLOSE"
        closable={false}
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <p>By clicking, I am providing my electronic signature expressly authorizing CURE to contact me by email, text, or phone (including an automatic dialing system or artificial/ prerecorded voice) at the home or mobile phone number provided within the application for information and documents related to my policy. Messaging and data rates may apply. I understand I am not required to sign or agree to this as a condition to apply for a policy with CURE.</p>
        <div className={`${RegisterStyle["left-roundy"]}`} />
      </Modal>
    </>
  )
}

Register.propTypes = {}

export default Register
